import actionConstants from '../constants/';

const getWalletList = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const walletActivationDeactivation = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const createBulkWalletState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const loadBulkWalletState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const listCreatedWalletState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const listLoadWalletState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const downloadRecordsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const transactionDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const walletBalanceState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: {},
  errorMessage: '',
};

const initialState = {
  walletList: { ...getWalletList },
  walletActivationDeactivation: { ...walletActivationDeactivation },
  createBulkWalletState: { ...createBulkWalletState },
  loadBulkWalletState: { ...loadBulkWalletState },
  listCreatedWalletState: { ...listCreatedWalletState },
  listLoadWalletState: { ...listLoadWalletState },
  downloadRecordsState: { ...downloadRecordsState },
  transactionDetailsState: { ...transactionDetailsState },
  walletBalanceState: { ...walletBalanceState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function walletReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_CUSTOMER_WALLET_REQUEST:
      return {
        ...state,
        walletList: {
          ...state.walletList,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_CUSTOMER_WALLET_SUCCESS:
      return {
        ...state,
        walletList: {
          ...state.walletList,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_CUSTOMER_WALLET_FAILURE:
      return {
        ...state,
        walletList: {
          ...state.walletList,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.GET_CUSTOMER_WALLET_CLEAR:
      return {
        ...state,
        walletList: {
          ...initialState.walletList,
          data: {},
        },
      };

    case actionConstants.CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_REQUEST:
      return {
        ...state,
        walletActivationDeactivation: {
          ...state.walletActivationDeactivation,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_SUCCESS:
      return {
        ...state,
        walletActivationDeactivation: {
          ...state.walletActivationDeactivation,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_FAILURE:
      return {
        ...state,
        walletActivationDeactivation: {
          ...state.walletActivationDeactivation,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.CUSTOMER_WALLET_ACTIVATION_DEACTIVATION_CLEAR:
      return {
        ...state,
        walletActivationDeactivation: {
          ...initialState.walletActivationDeactivation,
          data: {},
        },
      };

    case actionConstants.CREATE_BULK_WALLET_REQUEST:
      return {
        ...state,
        createBulkWalletState: {
          ...state.createBulkWalletState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.CREATE_BULK_WALLET_SUCCESS:
      return {
        ...state,
        createBulkWalletState: {
          ...state.createBulkWalletState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.CREATE_BULK_WALLET_FAILURE:
      return {
        ...state,
        createBulkWalletState: {
          ...state.createBulkWalletState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.CREATE_BULK_WALLET_CLEAR:
      return {
        ...state,
        createBulkWalletState: {
          ...initialState.createBulkWalletState,
          data: {},
        },
      };

    case actionConstants.LOAD_BULK_WALLET_REQUEST:
      return {
        ...state,
        loadBulkWalletState: {
          ...state.loadBulkWalletState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.LOAD_BULK_WALLET_SUCCESS:
      return {
        ...state,
        loadBulkWalletState: {
          ...state.loadBulkWalletState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.LOAD_BULK_WALLET_FAILURE:
      return {
        ...state,
        loadBulkWalletState: {
          ...state.loadBulkWalletState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.LOAD_BULK_WALLET_CLEAR:
      return {
        ...state,
        loadBulkWalletState: {
          ...initialState.loadBulkWalletState,
          data: {},
        },
      };

    case actionConstants.LIST_CREATED_WALLET_REQUEST:
      return {
        ...state,
        listCreatedWalletState: {
          ...state.listCreatedWalletState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.LIST_CREATED_WALLET_SUCCESS:
      return {
        ...state,
        listCreatedWalletState: {
          ...state.listCreatedWalletState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.LIST_CREATED_WALLET_FAILURE:
      return {
        ...state,
        listCreatedWalletState: {
          ...state.listCreatedWalletState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.LIST_CREATED_WALLET_CLEAR:
      return {
        ...state,
        listCreatedWalletState: {
          ...initialState.listCreatedWalletState,
          data: {},
        },
      };

    case actionConstants.LIST_LOAD_WALLET_REQUEST:
      return {
        ...state,
        listLoadWalletState: {
          ...state.listLoadWalletState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.LIST_LOAD_WALLET_SUCCESS:
      return {
        ...state,
        listLoadWalletState: {
          ...state.listLoadWalletState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.LIST_LOAD_WALLET_FAILURE:
      return {
        ...state,
        listLoadWalletState: {
          ...state.listLoadWalletState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.LIST_LOAD_WALLET_CLEAR:
      return {
        ...state,
        listLoadWalletState: {
          ...initialState.listLoadWalletState,
          data: {},
        },
      };

    case actionConstants.DOWNLOAD_ERROR_REPORT_REQUEST:
      return {
        ...state,
        downloadRecordsState: {
          ...state.downloadRecordsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.DOWNLOAD_ERROR_REPORT_SUCCESS:
      return {
        ...state,
        downloadRecordsState: {
          ...state.downloadRecordsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.DOWNLOAD_ERROR_REPORT_FAILURE:
      return {
        ...state,
        downloadRecordsState: {
          ...state.downloadRecordsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.DOWNLOAD_ERROR_REPORT_CLEAR:
      return {
        ...state,
        downloadRecordsState: {
          ...initialState.downloadRecordsState,
          data: {},
        },
      };

    case actionConstants.GET_WALLET_TRANSACTION_DETAILS_REQUEST:
      return {
        ...state,
        transactionDetailsState: {
          ...state.transactionDetailsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_WALLET_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        transactionDetailsState: {
          ...state.transactionDetailsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_WALLET_TRANSACTION_DETAILS_FAILURE:
      return {
        ...state,
        transactionDetailsState: {
          ...state.transactionDetailsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.GET_WALLET_TRANSACTION_DETAILS_CLEAR:
      return {
        ...state,
        transactionDetailsState: {
          ...initialState.transactionDetailsState,
          data: {},
        },
      };

    case actionConstants.GET_WALLET_DETAILS_REQUEST:
      return {
        ...state,
        walletBalanceState: {
          ...state.walletBalanceState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };

    case actionConstants.GET_WALLET_DETAILS_SUCCESS:
      return {
        ...state,
        walletBalanceState: {
          ...state.walletBalanceState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };

    case actionConstants.GET_WALLET_DETAILS_FAILURE:
      return {
        ...state,
        walletBalanceState: {
          ...state.walletBalanceState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.body.code,
          errorMessage:
            action.payload.body?.error_details?.error?.message ||
            action.payload.body?.message,
        },
      };

    case actionConstants.GET_WALLET_DETAILS_CLEAR:
      return {
        ...state,
        walletBalanceState: {
          ...initialState.walletBalanceState,
          data: {},
        },
      };

    default:
      return state;
  }
}
